import React from "react";
import ReactWOW from 'react-wow'
import "../Customers/Customers.css"
import Counter from "./Counter";
import OracleImg from "../../assets/images/customers/Oracle.svg"
import CarayonImg from "../../assets/images/customers/Carayon.svg"
import SunPharmaImg from "../../assets/images/customers/SunPharma.svg"
import PPGImg from "../../assets/images/customers/PPG.svg"
import TafeImg from "../../assets/images/customers/Tafe.svg"
import PepsicoImg from "../../assets/images/customers/Pepsico-new.svg"

const Customers = () => {
    return (
        <div className="container-fluid customers">  
            <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                    <div className="row d-flex justify-content-center">                        
                        <div className="col-lg-3 col-md-12 col-xs-12 center">
                            <ReactWOW delay='.2s' animation='fadeInUp'>
                                <div className="col-lg-5 col-md-5 col-xs-12"><Counter number={100} title="Used in" subtitle="Countries" decimals='+'/></div>
                            </ReactWOW>
                            <ReactWOW delay='.4s' animation='fadeInUp'>
                                <div className="col-lg-7 col-md-7 col-xs-12"><Counter number={125} title="Loved by" subtitle="Teams" decimals=',000+'/></div>
                            </ReactWOW>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12 center">
                            <ReactWOW delay='.6s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img src={OracleImg} alt='Oracle' /></div>
                            </ReactWOW>
                            <ReactWOW delay='.8s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img src={CarayonImg} alt='Carayon' /></div>
                            </ReactWOW>
                            <ReactWOW delay='1s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img src={SunPharmaImg} alt='SunPharma' /></div>
                            </ReactWOW>
                        </div>
                        
                        <div className="col-lg-4 col-md-6 col-xs-12 center">
                            <ReactWOW delay='1.2s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img src={PPGImg} alt='PPG' /></div>
                            </ReactWOW>
                            <ReactWOW delay='1.4s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img src={TafeImg} alt='Tafe' /></div>
                            </ReactWOW>
                            <ReactWOW delay='1.6s' animation='fadeInUp'>
                                <div className="col-lg-4 col-md-4 col-xs-4"><img className="pepsicoCustomers" src={PepsicoImg} alt='Pepsico' /></div>
                            </ReactWOW>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}

export default Customers